import FacebookButton from "./FacebookButton";
import GoogleButton from "./google-auth/GoogleButton";

const SocialAuth = () => {
  return (
    <div className="flex items-center bg-gray4 rounded-md  gap-2">
      {/* <FacebookButton /> */}
      <GoogleButton />
      
    </div>
  );
};

export default SocialAuth;
